export default __webpack_public_path__ + "static/media/12t.46df8deb.jpg";